import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, SelectChangeEvent } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../../../app/hooks';
import { updateTicketWorkflow } from '../../../../state';

const ResolutionStatusEdit: React.FC = () => {
  const dispatch = useAppDispatch();
  const { currentTicket } = useAppSelector(state => state.ticket);

  const handleChange = (event: SelectChangeEvent) => {
    dispatch(updateTicketWorkflow({ resolutionStatus: event.target.value }));
  };

  return (
    <FormControl size="small" fullWidth>
      <InputLabel>Resolution Status</InputLabel>
      <Select
        value={currentTicket?.workflow.resolutionStatus || ''}
        onChange={handleChange}
        label="Resolution Status"
      >
        <MenuItem value="">None</MenuItem>
        <MenuItem value="Fixed">Fixed</MenuItem>
        <MenuItem value="Won't Fix">Won't Fix</MenuItem>
        <MenuItem value="Duplicate">Duplicate</MenuItem>
        <MenuItem value="Cannot Reproduce">Cannot Reproduce</MenuItem>
        <MenuItem value="By Design">By Design</MenuItem>
      </Select>
    </FormControl>
  );
};

export default ResolutionStatusEdit;
